import * as React from 'react';
import DocumentOutlined from './document-outlined';
import DocumentFilled from './document-filled';
import type { IconCombinedProps } from './types';
const DocumentCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <DocumentFilled ref={ref} {...rest} />;
  }
  return <DocumentOutlined ref={ref} {...rest} />;
});
export default DocumentCombined;